import { useContext } from 'react';
import { TokenContext } from './CorreiosContext';

export const useCorreios = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error('useCorreios must be used within a TokenContextProvider');
  }
  return context;
};
